import { graphql } from '~/lib/graphql'

export const RestaurantGenre = graphql(`
  fragment RestaurantGenre on Restaurant {
    genre {
      displayName
      major {
        code
        name
      }
      minor {
        code
        name
      }
    }
  }
`)
